import {connect} from 'react-redux';
import FDESMere from '../components/FDESMere';

export default connect(
    (state) => ({
        localConfigurator: state.configurator.localConfigurator,
    }), null
)(FDESMere);